var map = {
	"./css3.svg": 953,
	"./html.svg": 478,
	"./img_1.png": 514,
	"./javascript.svg": 248,
	"./linkedin.svg": 903,
	"./logo-test.jpg": 185,
	"./logo-test1.png": 436,
	"./logo.png": 678,
	"./nodejs.svg": 68,
	"./react.svg": 254,
	"./resume.pdf": 764,
	"./vue.svg": 871
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 907;